import { render, staticRenderFns } from "./match-data.vue?vue&type=template&id=c5911566&scoped=true&"
import script from "./match-data.vue?vue&type=script&lang=js&"
export * from "./match-data.vue?vue&type=script&lang=js&"
import style0 from "./match-data.vue?vue&type=style&index=0&id=c5911566&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5911566",
  null
  
)

export default component.exports